import { FileText, ArrowUpRight, BookOpen, Presentation, HelpCircle, ClipboardList, Image as ImageIcon } from "lucide-react";
import { ASSET_BROCHURE_URL, ASSET_VIGOR_URL, ASSET_FLYER_URL, ASSET_QA_URL, buildPilotMailto } from "@/lib/mailto";

const items = [
  {
    icon: FileText,
    label: "LevelLeven brochure",
    hint: "Volledig programma-overzicht (PDF)",
    href: ASSET_BROCHURE_URL,
    external: true,
    kind: "download",
  },
  {
    icon: FileText,
    label: "LevelLeven × VIGOR",
    hint: "Van beweging naar geborgde skills (PDF)",
    href: ASSET_VIGOR_URL,
    external: true,
    kind: "download",
  },
  {
    icon: ImageIcon,
    label: "One-pager voor gemeenten",
    hint: "Wat als re-integratie nog een stap te ver is? (PNG)",
    href: ASSET_FLYER_URL,
    external: true,
    kind: "download",
  },
  {
    icon: HelpCircle,
    label: "Vraag & antwoord",
    hint: "Antwoorden op alle veelgestelde vragen (PDF)",
    href: ASSET_QA_URL,
    external: true,
    kind: "download",
  },
  {
    icon: BookOpen,
    label: "Core Profile, incluis evidence",
    hint: "Wetenschappelijk fundament en bronnen",
    href: buildPilotMailto({
      subject: "Aanvraag Core Profile LevelLeven",
      body: "Beste LevelLeven,\n\nGraag ontvangen wij het Core Profile inclusief de evidence.\n\nOrganisatie:\nContactpersoon + functie:\n\nMet vriendelijke groet,",
    }),
    external: true,
    kind: "mail",
  },
  {
    icon: BookOpen,
    label: "Productprofiel, incluis evidence",
    hint: "Uitgebreid productprofiel met onderbouwing",
    href: buildPilotMailto({
      subject: "Aanvraag Productprofiel LevelLeven",
      body: "Beste LevelLeven,\n\nGraag ontvangen wij het Productprofiel inclusief de evidence.\n\nOrganisatie:\nContactpersoon + functie:\n\nMet vriendelijke groet,",
    }),
    external: true,
    kind: "mail",
  },
  {
    icon: ClipboardList,
    label: "Pilotvoorstel op maat",
    hint: "Voorstel afgestemd op uw gemeente",
    href: buildPilotMailto({
      subject: "Aanvraag pilotvoorstel LevelLeven",
      body: "Beste LevelLeven,\n\nGraag ontvangen wij een pilotvoorstel op maat.\n\nGemeente:\nContactpersoon:\nFunctie:\nTelefoon:\n\nMet vriendelijke groet,",
    }),
    external: true,
    kind: "mail",
  },
  {
    icon: Presentation,
    label: "Presentatie voor het college",
    hint: "Slidedeck voor bestuurlijk overleg",
    href: buildPilotMailto({
      subject: "Aanvraag presentatie LevelLeven",
      body: "Beste LevelLeven,\n\nGraag ontvangen wij de presentatie voor bestuurlijk overleg.\n\nGemeente:\nContactpersoon:\n\nMet vriendelijke groet,",
    }),
    external: true,
    kind: "mail",
  },
];

export default function DownloadHub({ title = "Handleidingen & whitepapers" }) {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((d) => {
          const Icon = d.icon;
          return (
            <a
              key={d.label}
              href={d.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`downloadhub-item-${d.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group bg-[#FAF7F1] hover:bg-[#1D2A22] hover:text-[#FAF7F1] rounded-2xl p-7 border border-[#E5E1D8] transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-[#E06B3F]/10 group-hover:bg-[#E06B3F] text-[#E06B3F] group-hover:text-white flex items-center justify-center mb-6 transition-colors">
                <Icon size={20} />
              </div>
              <p className="font-heading text-2xl leading-tight">{d.label}</p>
              <p className="mt-2 text-sm text-[#4A5D4E] group-hover:text-[#FAF7F1]/70 leading-relaxed">
                {d.hint}
              </p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm">
                {d.kind === "download" ? "Openen" : "Aanvragen"}
                <ArrowUpRight size={14} />
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
